module.exports = __webpack_public_path__ + "img/icon_soccer_corner.d324f8ab.svg";